import http from '@/libs/javaAxios'
import MD5 from '@/libs/MD5'
import { getUserId } from '@/libs/util'
import store from '@/store'
import accountApi from "@/api/accountApi";
import userApi from "@/api/userApi";

export default class commonApi extends http {
  /**
   * APP下载信息
   * @method post

   */
  static uploadInfo = () => {
    const url = '/app/upload/info';
    return this.post(url);
  }

  /**
   * 单页
   * @method post
   * @param type 注册协议-agreement，绑卡协议-tied_card

   */
  static pagesInfo = (type) => {
    const url = '/pages/info';
    return this.post(url, { type });
  }

  /**
   * 广告位
   * @method post
   * @param advert_type APP首页轮播位-app_homepage
   * @param page_size

   */
  static advertList = ({ advert_type, page_size }) => {
    const url = '/system/advert/list';
    return this.post(url, { advert_type, page_size });
  }

  /**
   * 根据推广码获取用户信息
   * @method post
   * @param invitation_code 推广码

   */
  static invitationCode = (invitation_code) => {
    const url = '/invitation/code';
    return this.post(url, { advert_type });
  }

  /**
   * 获取区域列表 根据父类ID获取所有子类
   * @method post
   * @param location_id 父类ID

   */
  static locationParent = (location_id) => {
    const url = '/location/parent';
    return this.post(url, { location_id }, true);
  }

  /**
   * 短信验证码
   * @method post
   * @param phone 注册/登录手机号
   * @param sms_type 短信类型 1-注册/登录，2-设置交易密码
   * @param user_id 用户ID
   * @param is_h5 是否h5注册 0-否，1-是

   */
  static sendSmscode = (data) => {
    const url = '/send/smscode';
    return this.post(url, data);
  }

  /**
   * 获取分享注册页面配置
   * @method post

   */
  static systemShare = () => {
    const url = '/system/share';
    return this.post(url);
  }

  /**
   * 获取所有区域
   * @method post

   */
  static locationAll = () => {
    const url = '/location/all';
    return this.post(url);
  }

  /**
   * 获取所有系统配置
   * @method post

   */
  static systemConfig = () => {
    const url = '/system/config';
    return this.post(url);
  }

  /**
   * 递归获取区域
   * @method post

   */
  static locationSub = () => {
    const url = '/location/sub';
    return this.post(url);
  }
}